<script lang="ts">
    import { SvelteComponent, onMount } from "svelte";
    import isDescendant from "../../tools/isDescendant";
    export let title: string;
    export let icon: undefined | any | SvelteComponent;
    export let closeCallback: () => void | undefined;

    let modal: HTMLElement;
    if (closeCallback) {
        function globalClickHandler(e: MouseEvent) {
            if (modal !== e.target && !isDescendant(modal, e.target as Node)) {
                closeCallback();
            }
        }
        onMount(() => {
            document.addEventListener("click", globalClickHandler);
            return () => {
                document.removeEventListener("click", globalClickHandler);
            };
        });
    }
</script>

<div class="Modal">
    <div class="Modal__content" bind:this={modal}>
        {#if title}
            <div class="Modal__title">
                {#if icon}<svelte:component this={icon} />{/if}
                {title}
            </div>
        {/if}
        <slot />
    </div>
</div>

<style type="text/scss">
    @import "../../scss/config.scss";
    .Modal {
        position: fixed;
        width: 100vw;
        height: 100vw;
        top: 0;
        left: 0;
        background: rgba($color-medium-dark-grey, 0.7);
        z-index: 100;
        &__content {
            width: 90%;
            margin: auto;
            background: $color-white;
            margin-top: 40px;
        }
        &__title {
            border-bottom: 1px solid $color-medium-grey;
            padding: 5px 10px;
        }
    }
</style>
